import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllPathways(_obj, params) {
    const res = await axios.get(`api/pathways/`, { params });
    return res.data;
  },

  async getPathway(_obj, id) {
    const res = await axios.get(`api/pathways/${id}/`);
    return res.data;
  },

  async createPathway(_obj, data) {
    return axios.post(`api/pathways/`, data);
  },

  async updatePathway(_obj, { id, data }) {
    return axios.patch(`api/pathways/${id}/`, data);
  },

  async deletePathway(_obj, id) {
    return axios.delete(`api/pathways/${id}/`);
  },

  /** Signed handoff into the student's TransitionU membership for one of their enrollments. */
  async getStudioSignin(_obj, enrollmentId) {
    const res = await axios.get(`api/pathways/enrollments/${enrollmentId}/studio-signin/`);
    return res.data;
  },

  async getMyPathwayEnrollments(_obj, params) {
    const res = await axios.get(`api/pathways/enrollments/`, { params });
    return res.data;
  },

  async getAllPathwayEnrollments(_obj, params) {
    const res = await axios.get(`api/pathways/enrollments/`, { params });
    return res.data;
  },

  async getAllPathwayLeads(_obj, params) {
    const res = await axios.get(`api/pathways/leads/`, { params });
    return res.data;
  },

  async getPathwayLead(_obj, token) {
    const res = await axios.get(`api/pathways/leads/${token}/`);
    return res.data;
  },
};

export const pathways = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
